import { EventItem } from '~/types';

// Sample events — shown as a fallback when the API returns nothing.
export const sampleEvents: EventItem[] = [
    {
        id: 'sample-1',
        slug: 'community-design-jam',
        title: 'Community Design Jam',
        description:
            'A hands-on afternoon where designers and developers pair up to prototype ideas for the next release. Snacks, stickers and good company included.',
        imageUrl: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=1200&q=80',
        startDate: '2026-09-12T14:00:00Z',
        endDate: '2026-09-12T18:00:00Z',
        location: 'Innovation Hub, 4th Floor',
        status: 'upcoming',
    },
    {
        id: 'sample-2',
        slug: 'founders-fireside-chat',
        title: 'Founders Fireside Chat',
        description:
            'An intimate conversation with the founders on lessons learned scaling the platform, followed by an open Q&A with the audience.',
        imageUrl: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?auto=format&fit=crop&w=1200&q=80',
        startDate: '2026-09-20T17:30:00Z',
        endDate: '2026-09-20T19:00:00Z',
        location: 'The Loft, Downtown',
        status: 'upcoming',
    },
    {
        id: 'sample-3',
        slug: 'annual-members-summit',
        title: 'Annual Members Summit',
        description:
            'Our flagship full-day event bringing the whole community together for talks, workshops and a closing networking dinner.',
        imageUrl: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80',
        startDate: '2026-10-05T09:00:00Z',
        endDate: '2026-10-05T20:00:00Z',
        location: 'Grand Conference Centre, Hall B',
        status: 'scheduled',
        ticketTypes: [
            {
                title: 'Community',
                price: 0,
                description: 'Free access for verified members.',
                perks: ['Access to all talks', 'Networking lunch', 'Event swag'],
                available: true,
            },
            {
                title: 'Professional',
                price: 45,
                currency: 'USD',
                description: 'Full-day pass with workshop seats.',
                perks: ['Everything in Community', 'Reserved workshop seat', 'Closing reception & dinner'],
                available: true,
                featured: true,
            },
            {
                title: 'Team (5 seats)',
                price: 180,
                currency: 'USD',
                description: 'Bring the whole team and save.',
                perks: ['5 Professional passes', 'Dedicated team table', 'Group photo with speakers'],
                available: true,
            },
            {
                title: 'VIP',
                price: 120,
                currency: 'USD',
                description: 'Front-row seating and speaker dinner.',
                perks: ['Everything in Professional', 'Front-row seating', 'Private speaker dinner'],
                soldOut: true,
            }, 
        ],
        agenda: [
            { id: 'ag1', startTime: '2026-10-05T09:00:00Z', endTime: '2026-10-05T09:30:00Z', title: 'Registration & Welcome Coffee', responsibleParson: 'Secretariat / All', location: 'Main Foyer', track: 'General', isPhysical: true },
            { id: 'ag2', startTime: '2026-10-05T09:30:00Z', endTime: '2026-10-05T10:15:00Z', title: 'Opening Keynote: The Year Ahead', responsibleParson: 'Amara Okoye, CEO', location: 'Main Stage', track: 'Main Stage', isPhysical: true },
            { id: 'ag3', startTime: '2026-10-05T10:30:00Z', endTime: '2026-10-05T12:00:00Z', title: 'Workshop: Building with the Platform API', responsibleParson: 'Dev Relations Team', description: 'Hands-on session — bring a laptop.', location: 'Lab A', track: 'Lab A', isPhysical: true },
            { id: 'ag4', startTime: '2026-10-05T12:00:00Z', endTime: '2026-10-05T13:00:00Z', title: 'Networking Lunch', responsibleParson: 'Secretariat / All', location: 'Garden Terrace', track: 'General', isPhysical: true },
            { id: 'ag5', startTime: '2026-10-05T13:00:00Z', endTime: '2026-10-05T14:30:00Z', title: 'Panel: Scaling Community Programs', responsibleParson: 'Invited guests', location: 'Main Stage', track: 'Main Stage', isPhysical: true },
            { id: 'ag6', startTime: '2026-10-05T18:00:00Z', endTime: '2026-10-05T20:00:00Z', title: 'Welcome Reception', responsibleParson: 'Secretariat / All', location: 'Rooftop', track: 'Rooftop', isPhysical: true },
            { id: 'ag7', startTime: '2026-10-06T09:30:00Z', endTime: '2026-10-06T10:15:00Z', title: 'Day Two Keynote: Under the Hood', responsibleParson: 'Liang Wei', location: 'Main Stage', track: 'Main Stage', isVirtual: true },
            { id: 'ag8', startTime: '2026-10-06T10:30:00Z', endTime: '2026-10-06T12:00:00Z', title: 'Lightning Talks', description: 'Ten members, five minutes each.', location: 'Main Stage', track: 'Main Stage', isPhysical: true },
            { id: 'ag9', startTime: '2026-10-06T13:00:00Z', endTime: '2026-10-06T15:00:00Z', title: 'Unconference Sessions', description: 'Topics chosen by attendees on the day.', location: 'All Rooms', track: 'All Rooms', isPhysical: true },
            { id: 'ag10', startTime: '2026-10-06T18:00:00Z', endTime: '2026-10-06T20:00:00Z', title: 'Closing Dinner & Awards', responsibleParson: 'Secretariat / All', location: 'Rooftop', track: 'Rooftop', isPhysical: true },
        ],
        speakers: [
            {
                name: 'Amara Okoye',
                role: 'Chief Executive Officer',
                company: 'Dephics',
                country: 'Nigeria',
                photoUrl: 'https://i.pravatar.cc/300?img=47',
                topic: 'The Year Ahead: Vision and Roadmap',
                bio: 'Amara founded Dephics in 2018 after a decade building payments infrastructure across the continent. She leads company strategy and spends most of her time with customers and the community.',
                socials: [
                    { platform: 'twitter', url: 'https://twitter.com/' },
                    { platform: 'linkedin', url: 'https://linkedin.com/' },
                    { platform: 'website', url: 'https://example.com' },
                ],
            },
            {
                name: 'Liang Wei',
                role: 'Head of Engineering',
                company: 'Dephics',
                country: 'Singapore',
                photoUrl: 'https://i.pravatar.cc/300?img=12',
                topic: 'Under the Hood: Platform Architecture',
                bio: 'Liang oversees the platform and infrastructure teams. Before Dephics he worked on distributed databases and real-time systems.',
                socials: [
                    { platform: 'github', url: 'https://github.com/' },
                    { platform: 'linkedin', url: 'https://linkedin.com/' },
                ],
            },
            {
                name: 'Sofia Marchetti', role: 'Community Lead', company: 'OpenCircle', country: 'Italy',
                photoUrl: 'https://i.pravatar.cc/300?img=32',
                topic: 'Growing Programs That Last',
                bio: 'Sofia has built community programs for open-source and civic-tech organisations for over eight years, focused on volunteer retention and inclusive events.',
                socials: [
                    { platform: 'instagram', url: 'https://instagram.com/' },
                    { platform: 'website', url: 'https://example.com' },
                ],
            },
            {
                name: 'Daniel Mbanda', role: 'Founder', company: 'FieldKit', country: 'Tanzania',
                photoUrl: null,
                topic: 'From Prototype to Production',
                bio: 'Daniel builds offline-first tools for field research teams. He is a self-taught engineer and a frequent speaker on pragmatic product development.',
                socials: [
                    { platform: 'twitter', url: 'https://twitter.com/' },
                ],
            },
        ],
        amenities: [
            { id: 'a1', label: 'Free Wi-Fi', icon: 'wifi', description: 'High-speed wireless throughout the venue.' },
            { id: 'a2', label: 'On-site Parking', icon: 'parking', description: 'Complimentary parking for the first 200 guests.' },
            { id: 'a3', label: 'Catered Lunch', icon: 'food', description: 'Buffet lunch and all-day coffee station.' },
            { id: 'a4', label: 'Wheelchair Accessible', icon: 'accessible', description: 'Step-free access, lifts and accessible restrooms.' },
            { id: 'a5', label: 'Charging Stations', icon: 'charging', description: 'Device charging lockers near the main hall.' },
            { id: 'a6', label: 'Cloakroom', icon: 'cloakroom', description: 'Secure bag and coat storage.' },
            { id: 'a7', label: 'First Aid', icon: 'first-aid', description: 'Trained medics on site for the full day.' },
            { id: 'a8', label: 'Airport Shuttle', icon: 'shuttle', available: false, description: 'Not offered for this edition.' },
        ],
        exhibitors: [
            { name: 'FieldKit', category: 'Developer Tools', booth: 'A1', website: 'https://example.com', description: 'Offline-first data collection for field teams.' },
            { name: 'OpenCircle', category: 'Community Platform', booth: 'A2', description: 'Membership and engagement tooling.' },
            { name: 'BrightPay', category: 'Payments', booth: 'B3', website: 'https://example.com', description: 'Local payment rails for East Africa.' },
            { name: 'Cartograph', category: 'Mapping & GIS', booth: 'B4', description: 'Lightweight maps for the web.' },
        ],
        sponsors: [
            { id: 's1', name: 'Dephics', tier: 'Platinum', website: 'https://example.com', about: 'Platform partner powering the community.', position: 0 },
            { id: 's2', name: 'BrightPay', tier: 'Gold', website: 'https://example.com', about: 'Payments sponsor for the two-day programme.', position: 0 },
            { id: 's3', name: 'OpenCircle', tier: 'Gold', about: 'Community tooling sponsor.', position: 1 },
            { id: 's4', name: 'FieldKit', tier: 'Silver', website: 'https://example.com', position: 0 },
            { id: 's5', name: 'Cartograph', tier: 'Silver', position: 1 },
        ],
    },
];
